(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["habibi-custom-set-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.hcbInit) return;
      root.dataset.hcbInit = '1';
      var MAX = 5;
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-hcb-card]'));
      var slots = Array.prototype.slice.call(root.querySelectorAll('[data-hcb-slot]'));
      var props = Array.prototype.slice.call(root.querySelectorAll('[data-hcb-prop]'));
      var countEl = root.querySelector('[data-hcb-count]');
      var submit = root.querySelector('[data-hcb-submit]');
      var submitLabel = root.querySelector('[data-hcb-submit-label]');
      var picked = [];
      var price = (root.querySelector('.hcb__tray-price') || {}).textContent || '';

      function cardFor(title) { return cards.filter(function (c) { return c.dataset.title === title; })[0]; }
      function render() {
        slots.forEach(function (s, i) {
          var t = picked[i];
          var nameEl = s.querySelector('.hcb__slot-name');
          var x = s.querySelector('[data-hcb-remove]');
          if (t) { s.classList.add('is-filled'); nameEl.textContent = cardFor(t).dataset.name.replace(' & Oud', '').replace(' Absolute', '').replace(' Elixir', ''); x.hidden = false; x.dataset.title = t; }
          else { s.classList.remove('is-filled'); nameEl.textContent = 'Empty'; x.hidden = true; x.dataset.title = ''; }
          props[i].value = t || '';
        });
        cards.forEach(function (c) { c.querySelector('[data-hcb-pick]').setAttribute('aria-pressed', picked.indexOf(c.dataset.title) > -1 ? 'true' : 'false'); });
        countEl.textContent = picked.length;
        var trayNode = root.querySelector('[data-hcb-tray]'); if (trayNode) trayNode.classList.toggle('is-empty', picked.length === 0);
        var clearBtn = root.querySelector('[data-hcb-clear]'); if (clearBtn) clearBtn.hidden = picked.length === 0;
        var hint = root.querySelector('[data-hcb-hint]'); if (hint && picked.length < MAX) hint.hidden = true;
        var full = picked.length === MAX;
        root.classList.toggle('is-full', full);
        submit.disabled = !full;
        submit.setAttribute('aria-disabled', full ? 'false' : 'true');
        submitLabel.textContent = full ? ('Complete my set · ' + price) : ('Pick ' + (MAX - picked.length) + ' more to complete your set');
      }
      function toggle(title) {
        var i = picked.indexOf(title);
        if (i > -1) picked.splice(i, 1);
        else if (picked.length < MAX) picked.push(title);
        else {
          var tray = root.querySelector('[data-hcb-tray]'); if (tray) { tray.classList.add('is-shake'); setTimeout(function () { tray.classList.remove('is-shake'); }, 400); }
          var hint = root.querySelector('[data-hcb-hint]'); if (hint) { hint.hidden = false; clearTimeout(hint._t); hint._t = setTimeout(function () { hint.hidden = true; }, 3500); }
          return;
        }
        render();
      }
      var clearAll = root.querySelector('[data-hcb-clear]');
      if (clearAll) clearAll.addEventListener('click', function () { picked = []; render(); });
      cards.forEach(function (c) { c.querySelector('[data-hcb-pick]').addEventListener('click', function () { toggle(c.dataset.title); }); });
      root.querySelectorAll('[data-hcb-remove]').forEach(function (x) { x.addEventListener('click', function () { if (x.dataset.title) toggle(x.dataset.title); }); });

      // filters: scent world AND occasion, combined
      var fState = { fam: 'all', occ: 'all' };
      function has(list, key) { return key === 'all' || (' ' + (list || '') + ' ').indexOf(' ' + key + ' ') > -1; }
      function applyFilters() {
        var shown = 0;
        cards.forEach(function (c) { var on = has(c.dataset.fam, fState.fam) && has(c.dataset.occ, fState.occ); c.hidden = !on; if (on) shown++; });
        var empty = root.querySelector('[data-hcb-empty]'); if (empty) empty.hidden = shown > 0;
      }
      root.querySelectorAll('[data-hcb-filter]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          root.querySelectorAll('[data-hcb-filter]').forEach(function (k) { k.classList.remove('is-active'); k.setAttribute('aria-selected', 'false'); });
          chip.classList.add('is-active'); chip.setAttribute('aria-selected', 'true');
          fState.fam = chip.dataset.hcbFilter; applyFilters();
        });
      });
      root.querySelectorAll('[data-hcb-occ]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          root.querySelectorAll('[data-hcb-occ]').forEach(function (k) { k.classList.remove('is-active'); k.setAttribute('aria-selected', 'false'); });
          chip.classList.add('is-active'); chip.setAttribute('aria-selected', 'true');
          fState.occ = chip.dataset.hcbOcc; applyFilters();
        });
      });

      // scent world tiles: filter the grid to that world and bring the picker into view
      root.querySelectorAll('[data-hcb-world]').forEach(function (w) {
        w.addEventListener('click', function () {
          var chip = root.querySelector('[data-hcb-filter="' + w.dataset.hcbWorld + '"]');
          if (chip) chip.click();
          var p = root.querySelector('.hcb__picker'); if (p) p.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      // quick picks: names separated by |, matched loosely against card names
      root.querySelectorAll('[data-hcb-quick]').forEach(function (b) {
        b.addEventListener('click', function () {
          var wants = b.dataset.hcbQuick.split('|').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
          picked = [];
          wants.forEach(function (w) {
            var c = cards.filter(function (k) { return k.dataset.name.toLowerCase() === w || k.dataset.name.toLowerCase().indexOf(w) === 0; })[0];
            if (c && picked.length < MAX && picked.indexOf(c.dataset.title) < 0) picked.push(c.dataset.title);
          });
          render();
          var allChip = root.querySelector('[data-hcb-filter="all"]'); if (allChip) allChip.click();
          var allOcc = root.querySelector('[data-hcb-occ="all"]'); if (allOcc) allOcc.click();
          var target = root.querySelector('[data-hcb-tray]'); if (target) target.scrollIntoView({ behavior: 'smooth', block: 'end' });
        });
      });

      // hero CTA + empty-tray link scroll to picker
      root.querySelectorAll('[data-hcb-start]').forEach(function (start) {
        start.addEventListener('click', function (e) { e.preventDefault(); var p = root.querySelector('.hcb__picker'); if (p) p.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
      });

      // keep third-party bottom widgets (Klaviyo teaser) clear of the sticky tray on phones
      var trayEl = root.querySelector('[data-hcb-tray]');
      function liftWidgets() {
        if (!trayEl) return;
        var mobile = window.innerWidth < 750;
        var h = trayEl.getBoundingClientRect().height;
        document.querySelectorAll('[class*="kl-teaser"]').forEach(function (t) {
          if (mobile) { t.style.setProperty('bottom', Math.round(h + 12) + 'px', 'important'); t.style.setProperty('z-index', '29', 'important'); }
          else { t.style.removeProperty('bottom'); t.style.removeProperty('z-index'); }
        });
      }
      if (trayEl && window.ResizeObserver) new ResizeObserver(liftWidgets).observe(trayEl);
      window.addEventListener('resize', liftWidgets);
      var liftTries = 0; var liftTimer = setInterval(function () { liftWidgets(); if (++liftTries > 20) clearInterval(liftTimer); }, 1000);

      // submit: add the Sample Bundle line with properties[Product 1..5], then show the cart
      var form = root.querySelector('#hcb-form');
      var errEl = root.querySelector('[data-hcb-error]');
      function showErr(msg) { if (!errEl) return; errEl.textContent = msg; errEl.hidden = false; }
      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (picked.length !== MAX) { showErr('Choose five scents to complete your set.'); return; }
        if (errEl) errEl.hidden = true;
        submit.disabled = true; submitLabel.textContent = 'Adding to your bag…';
        var fd = new FormData(form);
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') { fd.append('sections', 'cart-drawer,cart-icon-bubble'); fd.append('sections_url', window.location.pathname); }
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (!data || data.status === 422 || data.status === 'error' || data.message) { throw new Error((data && (data.description || data.message)) || 'Could not add to bag'); }
            try { if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') { window.Rebuy.SmartCart.show(); submit.disabled = false; render(); return; } } catch (x) {}
            if (drawer && typeof drawer.renderContents === 'function' && data.sections) { try { drawer.renderContents(data); document.dispatchEvent(new CustomEvent('cart:refresh')); submit.disabled = false; render(); return; } catch (x) {} }
            window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
          })
          .catch(function (err) { submit.disabled = false; render(); showErr('Something went wrong adding your set. Please try again.'); if (window.console) console.error('hcb add failed', err); });
      });
      render();
    }
    function boot(scope) { scope.querySelectorAll('[data-hcb]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }); else boot(document);
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["habibi-discovery-single"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('habibi-discovery-single')) {
  customElements.define('habibi-discovery-single', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const form = this.querySelector('form.hww__form');
      if (!form) return;
      const quantity = form.querySelector('[name="quantity"]');
      const addon = form.querySelector('[data-addon-id]');
      const button = form.querySelector('[data-cta]');
      const error = form.querySelector('[data-error-message]');
      const errorCart = form.querySelector('[data-error-cart]');
      let base = Number(this.dataset.price);
      const format = new Intl.NumberFormat(this.dataset.locale || 'en-US', {style:'currency',currency:this.dataset.currency || 'USD'});
      const heroImg = this.querySelector('.hww__hero-image');
      const thumbs = this.querySelectorAll('.hww__thumb');
      thumbs.forEach(t => t.addEventListener('click', () => {
        if (!heroImg) return;
        heroImg.removeAttribute('srcset');
        heroImg.src = t.dataset.full;
        thumbs.forEach(x => x.classList.toggle('is-active', x === t));
      }));
      const update = () => {
        const n = Number(quantity.value);
        if (!Number.isInteger(n) || n < 1) return;
        const total = (base + (addon && addon.checked ? Number(addon.dataset.addonPrice) : 0)) * n;
        if (!button.disabled) button.textContent = this.dataset.cta + ' — ' + format.format(total / 100);
        const sp = this.querySelector('[data-sticky-price]');
        if (sp) sp.textContent = format.format(total / 100);
      };
      if (addon) {
        const box = this.querySelector('[data-addon-box]');
        if (box) box.hidden = false;
        addon.addEventListener('change', update);
      }
      const offers = form.querySelectorAll('[data-offer]');
      const idInput = form.querySelector('[name="id"]');
      const ship = this.querySelector('.hww__shipping');
      const contents = this.querySelector('.hww__contents');
      const priceLabel = this.querySelector('.hww__price > strong');
      offers.forEach(o => o.addEventListener('change', () => {
        if (!o.checked) return;
        base = Number(o.dataset.price);
        idInput.value = o.dataset.variant;
        const bundle = o.dataset.kind === 'bundle';
        offers.forEach(x => x.closest('.hww__offer-opt').classList.toggle('is-selected', x === o));
        if (ship) ship.textContent = bundle ? ship.dataset.shipBundle : ship.dataset.shipSingle;
        if (contents) contents.textContent = bundle ? contents.dataset.contentsBundle : contents.dataset.contentsSingle;
        if (priceLabel) priceLabel.textContent = format.format(base / 100);
        update();
      }));
      quantity.addEventListener('input', update);
      quantity.addEventListener('change', update);
      const sticky = this.querySelector('[data-sticky]');
      if ('IntersectionObserver' in window && sticky) {
        this.observer = new IntersectionObserver(([entry]) => {sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;},{threshold:0});
        this.observer.observe(button);
      }
      form.addEventListener('submit', async event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.busy || button.disabled || !form.reportValidity()) return;
        const n = Number(quantity.value);
        if (!Number.isInteger(n) || n < 1) return;
        const items = [{id:Number(form.querySelector('[name="id"]').value),quantity:n}];
        if (addon && addon.checked) items.push({id:Number(addon.dataset.addonId),quantity:n});
        this.busy = true;
        button.disabled = true;
        quantity.disabled = true;
        if (addon) addon.disabled = true;
        error.hidden = true;
        errorCart.hidden = true;
        button.textContent = this.dataset.busy;
        try {
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 20000);
          let response;
          try { response = await fetch(this.dataset.cartAdd, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items}),signal:controller.signal}); }
          finally { clearTimeout(timeout); }
          const result = await response.json();
          if (!response.ok || result.status >= 400) throw new Error('cart-rejected');
          if (!Array.isArray(result.items) || result.items.length !== items.length) throw new Error('cart-unconfirmed');
          let shown = false;
          try {
            if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              window.Rebuy.SmartCart.show();
              shown = true;
            }
          } catch (_) { shown = false; }
          if (!shown) { window.location.assign(this.dataset.cartUrl); return; }
          this.busy = false;
          button.disabled = false;
          quantity.disabled = false;
          if (addon) addon.disabled = false;
          update();
        } catch (_) {
          error.textContent = this.dataset.error;
          error.hidden = false;
          errorCart.hidden = false;
          error.tabIndex = -1;
          error.focus();
          this.busy = false;
          button.disabled = false;
          quantity.disabled = false;
          if (addon) addon.disabled = false;
          update();
        }
      }, true);
      update();
    }
    disconnectedCallback() {if (this.observer) this.observer.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["habibi-signature-offer"] && !Shopify.designMode) return;
  try {
    
  function initializeHabibiOffer(scope) {
    scope.querySelectorAll('[data-habibi-offer]').forEach(function (offer) {
      var sticky = offer.querySelector('[data-habibi-sticky]');
      var main = offer.querySelector('[data-habibi-main-cta]');
      var closing = offer.querySelector('[data-habibi-closing]');
      if (!sticky || !main || offer.dataset.stickyInitialized || !('IntersectionObserver' in window)) return;
      offer.dataset.stickyInitialized = 'true';
      offer.classList.add('habibi-offer--sticky-ready');
      var mainBelow = false;
      var closingVisible = false;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === main) mainBelow = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          if (entry.target === closing) closingVisible = entry.isIntersecting;
        });
        sticky.hidden = !mainBelow || closingVisible;
      });
      observer.observe(main);
      if (closing) observer.observe(closing);
    });
    scope.querySelectorAll('[data-habibi-offer] .habibi-offer__quantity').forEach(function (control) {
      if (control.dataset.initialized) return;
      var input = control.querySelector('input');
      if (!input) return;
      control.dataset.initialized = 'true';
      control.classList.add('habibi-offer__quantity--enhanced');
      control.querySelectorAll('[data-quantity-step]').forEach(function (button) {
        button.hidden = false;
        button.addEventListener('click', function () {
          var minimum = Number(input.min) || 1;
          var step = Number(input.step) || 1;
          var maximum = input.max ? Number(input.max) : Infinity;
          var value = Number(input.value);
          if (!Number.isFinite(value)) value = minimum;
          value += Number(button.dataset.quantityStep) * step;
          input.value = Math.min(maximum, Math.max(minimum, value));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }
  function initializeHabibiGallery(scope) {
    scope.querySelectorAll('[data-hab-gal]').forEach(function (gal) {
      if (gal.dataset.galInit) return;
      gal.dataset.galInit = 'true';
      var track = gal.querySelector('[data-hab-gal-track]');
      var slides = Array.prototype.slice.call(gal.querySelectorAll('[data-hab-gal-slide]'));
      var dotsWrap = gal.querySelector('[data-hab-gal-dots]');
      if (!track || slides.length < 2) {
        gal.querySelectorAll('.hab-gal__arrow').forEach(function (b) { b.hidden = true; });
        return;
      }
      var current = 0;
      var dots = slides.map(function (slide, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'hab-gal__dot';
        d.setAttribute('role', 'tab');
        d.setAttribute('aria-label', 'Photo ' + (i + 1) + ' of ' + slides.length);
        d.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        d.addEventListener('click', function () { goTo(i); });
        if (dotsWrap) dotsWrap.appendChild(d);
        return d;
      });
      function setActive(i) {
        current = i;
        dots.forEach(function (d, j) { d.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
      }
      function goTo(i) {
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        setActive(i);
      }
      var prev = gal.querySelector('[data-hab-gal-prev]');
      var next = gal.querySelector('[data-hab-gal-next]');
      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); });
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          var w = track.clientWidth || 1;
          var i = Math.round(track.scrollLeft / w);
          if (i !== current && i >= 0 && i < slides.length) setActive(i);
        });
      }, { passive: true });
    });
    scope.querySelectorAll('.habibi-creators__player video').forEach(function (v) {
      if (v.dataset.init) return;
      v.dataset.init = 'true';
      var wrap = v.parentNode;
      v.addEventListener('play', function () {
        wrap.classList.add('is-playing');
        document.querySelectorAll('.habibi-creators__player video').forEach(function (o) { if (o !== v && !o.paused) o.pause(); });
      });
      v.addEventListener('pause', function () { wrap.classList.remove('is-playing'); });
      v.addEventListener('ended', function () { wrap.classList.remove('is-playing'); });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeHabibiOffer(document); initializeHabibiGallery(document); });
  } else {
    initializeHabibiOffer(document);
    initializeHabibiGallery(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initializeHabibiOffer(event.target); initializeHabibiGallery(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["habibi-womens-wardrobe"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('habibi-womens-wardrobe')) {
  customElements.define('habibi-womens-wardrobe', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const form = this.querySelector('form.hww__form');
      if (!form) return;
      const quantity = form.querySelector('[name="quantity"]');
      const addon = form.querySelector('[data-addon-id]');
      const button = form.querySelector('[data-cta]');
      const error = form.querySelector('[data-error-message]');
      const errorCart = form.querySelector('[data-error-cart]');
      const base = Number(this.dataset.price);
      const format = new Intl.NumberFormat(this.dataset.locale || 'en-US', {style:'currency',currency:this.dataset.currency || 'USD'});
      const heroImg = this.querySelector('.hww__hero-image');
      const thumbs = this.querySelectorAll('.hww__thumb');
      thumbs.forEach(t => t.addEventListener('click', () => {
        if (!heroImg) return;
        heroImg.removeAttribute('srcset');
        heroImg.src = t.dataset.full;
        thumbs.forEach(x => x.classList.toggle('is-active', x === t));
      }));
      const update = () => {
        const n = Number(quantity.value);
        if (!Number.isInteger(n) || n < 1) return;
        const total = (base + (addon && addon.checked ? Number(addon.dataset.addonPrice) : 0)) * n;
        if (!button.disabled) button.textContent = this.dataset.cta + ' — ' + format.format(total / 100);
        const sp = this.querySelector('[data-sticky-price]');
        if (sp) sp.textContent = format.format(total / 100);
      };
      if (addon) {
        const box = this.querySelector('[data-addon-box]');
        if (box) box.hidden = false;
        addon.addEventListener('change', update);
      }
      quantity.addEventListener('input', update);
      quantity.addEventListener('change', update);
      const sticky = this.querySelector('[data-sticky]');
      if ('IntersectionObserver' in window && sticky) {
        this.observer = new IntersectionObserver(([entry]) => {sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;},{threshold:0});
        this.observer.observe(button);
      }
      form.addEventListener('submit', async event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.busy || button.disabled || !form.reportValidity()) return;
        const n = Number(quantity.value);
        if (!Number.isInteger(n) || n < 1) return;
        const items = [{id:Number(form.querySelector('[name="id"]').value),quantity:n}];
        if (addon && addon.checked) items.push({id:Number(addon.dataset.addonId),quantity:n});
        this.busy = true;
        button.disabled = true;
        quantity.disabled = true;
        if (addon) addon.disabled = true;
        error.hidden = true;
        errorCart.hidden = true;
        button.textContent = this.dataset.busy;
        try {
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 20000);
          let response;
          try { response = await fetch(this.dataset.cartAdd, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items}),signal:controller.signal}); }
          finally { clearTimeout(timeout); }
          const result = await response.json();
          if (!response.ok || result.status >= 400) throw new Error('cart-rejected');
          if (!Array.isArray(result.items) || result.items.length !== items.length) throw new Error('cart-unconfirmed');
          let shown = false;
          try {
            if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              window.Rebuy.SmartCart.show();
              shown = true;
            }
          } catch (_) { shown = false; }
          if (!shown) { window.location.assign(this.dataset.cartUrl); return; }
          this.busy = false;
          button.disabled = false;
          quantity.disabled = false;
          if (addon) addon.disabled = false;
          update();
        } catch (_) {
          error.textContent = this.dataset.error;
          error.hidden = false;
          errorCart.hidden = false;
          error.tabIndex = -1;
          error.focus();
          this.busy = false;
          button.disabled = false;
          quantity.disabled = false;
          if (addon) addon.disabled = false;
          update();
        }
      }, true);
      update();
    }
    disconnectedCallback() {if (this.observer) this.observer.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
